import {type FunctionalComponent, h} from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export const ConversationalSearchInputErrorMessage: FunctionalComponent<{
  labelProvider: labelProviderInterface;
}> = (props) => (
  <section class="conversation-search-input-error-message">
    <qds-icon library="core" name="clear" />
    <span>{props.labelProvider(
      'conversational.search.textarea.error.message',
      'Please type in your product related question here.'
    )}</span>
  </section>
);
